/**
 * Authentication Hook
 * Provides access to auth context with proper error handling
 */

import { useContext } from 'react';
import { AuthContext } from '@/contexts/auth-context';

export function useAuth() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export function useRequireAuth() {
  const auth = useAuth();

  if (!auth.isAuthenticated && !auth.isLoading) {
    return {
      ...auth,
      requiresLogin: true,
    };
  }

  return {
    ...auth,
    requiresLogin: false,
  };
}

export function useOptionalAuth() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    return {
      user: null,
      isLoading: false,
      isAuthenticated: false,
      isConfigured: false,
      error: null,
    };
  }

  return context;
}
